import React from "react"

const Quote = (props) =>{
	return <h2>{props.quote}</h2>
}






export default Quote